
export class ExcelPasteData {
    public constructor(public pasteData: string) {
    }
}
